import { action, observable, computed, reaction, toJS } from 'mobx';

/**
 * Хранилище маршрута браузера
 */
export default class RouteStore {

	history;

	// Текущий путь маршрута
	@observable path;

	// Параметры маршрута, то что после '?'
	@observable params;

	// Хэш часть маршрута, то что после '#'
	@observable hash;

	// Признак автопуша
	_autoPush = false;

	// Функция отключени прослушки стора запущенная через reaction
	_dispose;

	// Функция декодирования из uri в json
	_decodeFunction;

	// Функция кодирования из json в uri
	_encodeFunction;

	constructor ({autoPush, history, decode, encode} = {autoPush: false}) {
		this._autoPush = autoPush;
		this._decodeFunction = decode;
		this._encodeFunction = encode;
		this.history = history;
		this.history.listen (this._onChange);
		this._onChange ();
	}

	/**
	 * Добавить текущее состояние хранилища в историю
	 */
	@action push (location) {
		// сохраняем изменения в хранилище
		Object.assign (this, location);
		this.history.push (this._location ());
	}

	/**
	 * Обновляет хранилище при изменении маршрута
	 */
	@action _onChange = (location, action) => {
		// Отключаем прослушку изменений хранилища чтобы не было зацикливания
		this._dispose && this._dispose ();

		console.log ('RouteStore._onChange', this.history.location);

		const pathChanged = (this.path !== this.history.location.pathname) && location && action !== 'POP';

		this.path = this.history.location.pathname;

		// если изменился путь то очищаем params/hash
		this.params = !pathChanged ? this._decode (this.history.location.search) : undefined;
		this.hash = !pathChanged ? this._decode (this.history.location.hash) : undefined;

		// Включаем прослушку изменений path/params/hash если autoPush = true
		if (this._autoPush) {
			this._dispose = reaction (this._location, location => this.history.push (location));
		}
	};

	/**
	 * Возвращает объект location в формате history
	 * Используется также как функци данных для reaction
	 */
	_location = () => ({
		pathname: this.path,
		search: this._encode (toJS(this.params)),
		hash: this._encode (toJS(this.hash))
	});

	_decode = (component) => {
		return (component && this._decodeFunction) ?
			// substr (1) убирает лидирующий символ '?' или '#'
			this._decodeFunction (component.substr (1)) :
			undefined
		;
	};

	_encode = (json) => {
		return (json && this._encodeFunction) ?
			this._encodeFunction (json) :
			undefined
		;
	};
};
